import React from "react";
import { useAtom } from "jotai";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm } from "../../../common/DataList";
import { differedSearchAtom, paginationAtom, searchAtom } from "../useSuiviAnomalyList";

let differedTimeout = null;

// Critères du suivi (filtrage en mémoire des anomalies chargées) : mêmes clés
// qu'avant ; une clé vidée est retirée de la recherche, comme avant.
export const definitionsSuivi = (constants = {}) => [
  { name: "recipientName", group: "allocataire", label: "Nom", placeholder: "Nom, prénom", size: "md" },
  { name: "recipientEmail", group: "allocataire", label: "Email", placeholder: "Email", size: "md" },
  { name: "recipientNir", group: "allocataire", label: "NIR", placeholder: "NIR", size: "md" },
  { name: "recipientCAFId", group: "allocataire", label: "Matricule", placeholder: "Matricule", size: "sm" },
  {
    name: "recipientType",
    group: "criteres",
    label: "Type d'allocataire",
    type: "segmented",
    firstOptionLabel: "Tous",
    options: [
      { id: "UserRecipient", name: "Flux" },
      { id: "UserRecipientDSP", name: "Temporaire" },
    ],
  },
  {
    name: "rsaType",
    group: "criteres",
    label: "Type de droit",
    type: "select",
    firstOptionLabel: "Tous",
    options: constants.RSA_TYPES || [],
  },
  {
    name: "dateEnvoiNotif1",
    group: "criteres",
    label: "Envoi de la 1ère sollicitation",
    type: "dateRange",
    from: "debutDateEnvoiNotif1",
    to: "finDateEnvoiNotif1",
    fromLabel: "Date envoi 1ère sollicitation entre le",
    toLabel: "Et le",
  },
  { name: "onlyWithoutRDSP", group: "criteres", label: "Uniquement sans RDO", type: "checkbox" },
  { name: "onlyWithoutRdvEG", group: "criteres", label: "Uniquement sans RDV EG", type: "checkbox" },
];

const GROUPES = [
  { id: "allocataire", title: "Allocataire" },
  { id: "criteres", title: "Critères" },
];

function SuiviAnomalyListFilters({ constants }) {
  const [search, setSearch] = useAtom(searchAtom);
  const [, setDifferedSearch] = useAtom(differedSearchAtom);
  const [, setPagination] = useAtom(paginationAtom);

  const updateSearch = (e) => {
    clearTimeout(differedTimeout);
    var { value, name, checked, type, formArray } = e.target;
    let su = { ...search };

    if (type == "checkbox") {
      if (checked) {
        su[name] = true;
      } else {
        delete su[name];
      }
    } else if (formArray) {
      if (formArray.target.checked) {
        su[name].push(value);
      } else {
        su[name] = su[name].filter((f) => f != value);
      }
    } else {
      if (value == "") {
        delete su[name];
      } else {
        su[name] = value;
      }
    }

    setSearch(su);
  };

  // Valeur posée directement (croix d'une période) : même règle qu'une saisie,
  // appliquée sur l'état courant pour enchaîner les deux dates.
  const poser = (name, value) =>
    setSearch((s) => {
      const su = { ...s };
      if (value === "" || value === null || value === undefined) delete su[name];
      else su[name] = value;
      return su;
    });

  const applyFilters = (overrideFilters = null) => {
    setPagination((p) => ({ ...p, page: 1 }));
    setDifferedSearch(overrideFilters || search);
  };

  const resetSearch = () => {
    const newSearch = {
      recipientName: "",
      recipientEmail: "",
      recipientNir: "",
      recipientCAFId: "",
      onlyWithoutRDSP: false,
      onlyWithoutRdvEG: false,
      debutDateEnvoiNotif1: "",
      finDateEnvoiNotif1: "",
      rsaType: "",
      recipientType: "",
    };
    setSearch(newSearch);
    applyFilters(newSearch);
  };

  const definitions = definitionsSuivi(constants);

  return (
    <ListSearchForm onSubmit={() => applyFilters()} aria-label="Filtrer le suivi des anomalies">
      <FilterPanel
        id="suivi-anomalies-filters"
        title="Filtres"
        onReset={resetSearch}
        resetLabel="Vider les filtres"
        applyLabel="Rechercher"
      >
        {GROUPES.map((groupe) => (
          <FilterGroup key={groupe.id} title={groupe.title}>
            {definitions
              .filter((d) => d.group === groupe.id)
              .map((definition) => (
                <FilterField
                  key={definition.name}
                  definition={definition}
                  value={search[definition.name]}
                  values={search}
                  onChange={updateSearch}
                  onSet={poser}
                />
              ))}
          </FilterGroup>
        ))}
      </FilterPanel>
    </ListSearchForm>
  );
}

export default SuiviAnomalyListFilters;
